import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, HeartCrack } from 'lucide-react';
export function StorySection() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-170">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-30 pointer-events-none" data-id="element-171">
        <div className="absolute top-20 -left-32 w-96 h-96 rounded-full bg-[#FAF5E9] blur-3xl" data-id="element-172"></div>
        <div className="absolute bottom-20 -right-32 w-96 h-96 rounded-full bg-[#FAF5E9] blur-3xl" data-id="element-173"></div>
      </div>

      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-174">
        {/* Pain Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-175">
          <div className="flex justify-center mb-6" data-id="element-176">
            <HeartCrack className="w-10 h-10 text-[#C5A059] opacity-80" data-id="element-177" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-6 leading-tight" data-id="element-178">
            El peso invisible que cargas todos los días...
          </h2>
          <div className="space-y-6 text-stone-600 text-lg leading-relaxed text-left md:text-center" data-id="element-179">
            <p data-id="element-180">
              Conozco ese nudo en el estómago que aparece cada vez que hay que
              pagar las cuentas. Conozco las discusiones desgastantes por dinero
              que enfrían tu relación y roban la paz de tu hogar.
            </p>
            <p data-id="element-181">
              Esa ansiedad constante, el insomnio calculando cómo llegar a fin
              de mes, y ese miedo paralizante al imaginar un futuro incierto y
              lleno de carencias. Sientes que trabajas sin parar, pero el dinero
              se escurre como arena entre los dedos.{' '}
              <strong data-id="element-182">
                Ese dolor no es tu destino, es un síntoma de una energía
                estancada.
              </strong>
            </p>
          </div>
        </motion.div>

        {/* Parable Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-[#FAF5E9] rounded-3xl p-8 md:p-12 shadow-sm border border-[#C5A059]/10 relative" data-id="element-183">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md border border-stone-100" data-id="element-184">
            <Droplets className="w-6 h-6 text-[#C5A059]" data-id="element-185" />
          </div>

          <h3 className="text-2xl md:text-3xl font-serif font-bold text-stone-900 mb-6 text-center mt-4" data-id="element-186">
            La Parábola del Río de la Abundancia
          </h3>

          <div className="space-y-6 text-stone-700 text-lg leading-relaxed" data-id="element-187">
            <p data-id="element-188">
              Imagina que el dinero es como un río caudaloso, infinito y
              cristalino. Frente a este río, hay dos tipos de mujeres.
            </p>
            <p data-id="element-189">
              La primera mujer, impulsada por el miedo y la escasez, entra al
              agua desesperada. Intenta atrapar el agua con sus manos, apretando
              los puños con fuerza, luchando contra la corriente, aterrorizada
              de que se le escape. Termina exhausta, lastimada, y al abrir sus
              manos... <strong data-id="element-190">están vacías.</strong>
            </p>
            <p data-id="element-191">
              La segunda mujer conoce el código. Ella no lucha contra el río.
              Ella respira, prepara su balde con calma y simplemente lo sumerge.
              Fluye con el agua, sin resistencia, sabiendo con absoluta certeza
              que el río jamás se secará y que{' '}
              <strong data-id="element-192">siempre, siempre habrá suficiente para ella.</strong>
            </p>
            <p className="font-medium text-stone-900 text-center pt-4 text-xl font-serif italic" data-id="element-193">
              ¿Qué mujer decides ser a partir de hoy?
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}